export const couponFormStyles = {
  productInput: {
    width: 'auto',
  },
};
